import { render, staticRenderFns } from "./ProfilePaymentCards.vue?vue&type=template&id=38ae11fa&scoped=true&"
import script from "./ProfilePaymentCards.vue?vue&type=script&lang=js&"
export * from "./ProfilePaymentCards.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePaymentCards.vue?vue&type=style&index=0&id=38ae11fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ae11fa",
  null
  
)

export default component.exports